import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
/**
 * A schedule of activities
 */
export const scheduleOfActivitiesNameMaxLength = 60;
export function toScheduleOfActivities(scheduleOfActivities) {
    checkDefined(scheduleOfActivities.epochConfigurationId, 'ScheduleOfActivities', 'epochConfigurationId');
    return {
        ...toBaseStudyEntity(scheduleOfActivities, StudyEntityType.ScheduleOfActivities),
        epochConfigurationId: scheduleOfActivities.epochConfigurationId,
        scheduleOfActivitiesOverlayIds: scheduleOfActivities.scheduleOfActivitiesOverlayIds,
        name: scheduleOfActivities.name,
    };
}
//# sourceMappingURL=schedule-of-activities.js.map